var patternRoute = function (pattern, regexp, fn) {
    var result = fn;
    result.pattern = pattern;
    result.regexp = regexp;
    return result;
};
export var routes = {
    root: '/',
    login: '/login',
    signUp: '/sign-up',
    appSumoSignUp: '/appsumo',
    forgotPassword: '/forgot-password',
    dashboard: '/dashboard',
    dashboardWelcome: '/dashboard/welcome',
    teamDashboard: patternRoute('/teams/:id(\\d+)/dashboard', /^\/teams\/(\d+)\/dashboard$/, function (id) { return "/teams/" + id + "/dashboard"; }),
    dashboardArchive: '/dashboard/archived',
    teamArchive: patternRoute('/teams/:id(\\d+)/dashboard/archived', /^\/teams\/(\d+)\/dashboard\/archived$/, function (id) { return "/teams/" + id + "/dashboard/archived"; }),
    export: '/export',
    product: patternRoute('/products/:id(\\d+)', /^\/products\/(\d+)$/, function (id) { return "/products/" + id; }),
    productTeam: patternRoute('/teams/:id(\\d+)/members', /^\/teams\/(\d+)\/members$/, function (id) { return "/teams/" + id + "/members"; }),
    productTeamSettings: patternRoute('/teams/:id(\\d+)/settings', /^\/teams\/(\d+)\/settings$/, function (id) { return "/teams/" + id + "/settings"; }),
    /**
     * @deprecated
     */
    productNote: patternRoute('/products/:id(\\d+)/note/:noteId', /^\/products\/(\d+)\/note\/(\d+)$/, function (productId, noteId) { return "/products/" + productId + "/note/" + noteId; }),
    productNotes: patternRoute('/products/:id(\\d+)/notes/:noteId', /^\/products\/(\d+)\/notes\/(\d+)$/, function (productId, noteId) { return "/products/" + productId + "/notes/" + noteId; }),
    productImages: patternRoute('/products/:id(\\d+)/images/:imgId', /^\/products\/(\d+)\/images\/(\d+)$/, function (productId, imgId) { return "/products/" + productId + "/images/" + imgId; }),
    /**
     * @deprecated
     */
    products: "/products",
    settings: '/settings',
    profile: '/settings/profile',
    notifications: '/settings/notifications',
    changePassword: '/settings/password',
    billing: '/settings/billing',
    billingPay: '/settings/billing/pay',
    appSumo: '/settings/appsumo',
};
//# sourceMappingURL=routes.js.map